import { AtlassianIcon } from "#components/ui/AtlassianIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const atlassianManifest: IntegrationManifest = {
    key: "atlassian",
    displayName: "Atlassian",
    nameKey: "channels.atlassian",
    descriptionKey: "atlassianDescription",
    trayDescriptionKey: "composerTrayDescriptions.atlassian",
    cardDescriptionKey: "connectIntegration.descriptions.atlassian",
    connectedContentKeys: ["atlassianContent"],
    brandColor: "#0052CC",
    iconUrl: IconAssets.Atlassian,
    iconUrlAlt: IconAssets.AtlassianAlt,
    glyph: AtlassianIcon,
    channelType: "UserAtlassianMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: [],
    // Rovo citations carry a per-item kind: a Jira issue or Confluence page gets that product's
    // own logo instead of the generic Atlassian one above. jira_issue/confluence_page reuse the
    // classic integrations' assets; loom_video gets its own real Loom mark.
    itemKindChannels: {
        jira_issue: { nameKey: "channels.jira", iconUrl: IconAssets.Jira, iconUrlAlt: IconAssets.JiraAlt },
        confluence_page: { nameKey: "channels.confluence", iconUrl: IconAssets.Confluence, iconUrlAlt: IconAssets.ConfluenceAlt },
        loom_video: { nameKey: "channels.loom", iconUrl: IconAssets.Loom, iconUrlAlt: IconAssets.LoomAlt }
    }
};
